import React, { useState } from "react";
import Select from "react-select";
import { sortByOptions } from "../contants/data";

const SortBy = ({ onSortBy }) => {
  const [selectedSortBy, setSelectedSortBy] = useState(sortByOptions[0]);

  const handleSortByChange = (option) => {
    setSelectedSortBy(() => option);
    onSortBy(option);
  };

  return (
    <div>
      <Select
        options={sortByOptions}
        onChange={handleSortByChange}
        value={selectedSortBy}
        className="border-0"
      />
    </div>
  );
};

export default SortBy;
